import { sqliteTable, text, integer, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// print_templates — เทมเพลตสำหรับพิมพ์เอกสาร (Invoice, Booking, Receipt ฯลฯ)
// ============================================================================
export const printTemplates = sqliteTable("core_print_templates", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),

  // Template identity
  name: text("name").notNull(), // "ใบแจ้งหนี้ มาตรฐาน"
  slug: text("slug").notNull(), // "invoice-standard"
  module: text("module").notNull(), // "accounting"
  doctype: text("doctype").notNull(), // "invoices"

  // Template content
  htmlTemplate: text("html_template").notNull(), // HTML + Handlebars
  cssStyles: text("css_styles"), // Custom CSS
  headerHtml: text("header_html"), // Page header (optional)
  footerHtml: text("footer_html"), // Page footer (optional)

  // PDF overlay source
  sourceType: text("source_type").notNull().default("html"), // html, pdf_overlay
  sourceFileKey: text("source_file_key"), // R2 key for uploaded PDF template
  sourceFileName: text("source_file_name"),
  sourceFileSize: integer("source_file_size"),
  sourceContentType: text("source_content_type"),
  sourcePageCount: integer("source_page_count"),
  sourcePageSizesJson: text("source_page_sizes_json"), // [{ page, width, height, unit }]
  overlayFieldsJson: text("overlay_fields_json"), // PDF overlay field boxes

  // Settings
  paperSize: text("paper_size").notNull().default("A4"), // A4, Letter, A5
  orientation: text("orientation").notNull().default("portrait"), // portrait, landscape
  marginTop: integer("margin_top").default(20), // mm
  marginBottom: integer("margin_bottom").default(20),
  marginLeft: integer("margin_left").default(15),
  marginRight: integer("margin_right").default(15),

  // Metadata
  isDefault: integer("is_default", { mode: "boolean" }).default(false),
  isSystem: integer("is_system", { mode: "boolean" }).default(false),
  sortOrder: integer("sort_order").default(0),

  // Timestamps
  createdAt: text("created_at").notNull(),
  updatedAt: text("updated_at").notNull(),
  createdBy: text("created_by"),
}, (table) => [
  index("idx_print_templates_company_doctype").on(table.companyId, table.module, table.doctype),
]);

// Type exports
export type PrintTemplate = typeof printTemplates.$inferSelect;
export type NewPrintTemplate = typeof printTemplates.$inferInsert;
